export default __webpack_public_path__ + "static/media/2_LGBTQ+.d0e4da2d.svg";